import {AppState} from "../store";

export const getShiftPageFilter = (state: AppState) => state.shiftPage.filter
export const getShiftPageState = (state: AppState) => state.shiftPage.state
